<template>
  <div
    v-if="data && data.properties && data.properties.filed_content != 'Hide'"
  >
    <el-row>
      <el-col v-if="!data?.properties?.hideLabel" :span="24">
        <label
          for="text"
          v-if="hasLabel && !(data?.properties && data?.properties?.hideLabel)"
          :style="getLabelStyles"
        >
          {{ data.label }}
        </label>
        <span
          v-if="data?.validations && data?.validations?.required"
          style="color: red; font-weight: bold"
        >
          *
        </span>
      </el-col>
    </el-row>

    <div v-if="!isView || ( form[data.key] && allowToReschedule)" style="height: 150px">
      <div class="outer">
        <div class="inner">
          <div v-if="computedTimeSlots.length" class="slots">
            <div
              v-for="slot in computedTimeSlots"
              :key="slot.start"
              class="slot"
              :class="{
                available: isSlotAvailable(slot.start),
                selected: selectedSlot === slot.start,
                disabled: !isSlotAvailable(slot.start),
              }"
              @click="isSlotAvailable(slot.start) && selectSlot(slot.start)"
            >
              <span v-if="bufferTime === 0">{{ slot.start }}</span>
              <span v-else>{{ slot.start }} - {{ slot.end }}</span>
            </div>
          </div>
          <div v-else style="margin-top: 10px; color: #999; height: 100px">
            No slots available.
          </div>
        </div>
      </div>
    </div>
    <!-- When in view mode -->
    <div v-else style="margin-top: 10px">
      {{ form[data.key] || "No slot selected." }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { postAPICall } from "@/helpers/httpHelper";
export default {
  props: [
    "data",
    "value",
    "isActive",
    "isView",
    "hasLabel",
    "isDataTableField",
    "isInDataTable",
    "labelAlignments",
    "fieldsData",
    "allFields",
    "templatesData",
    "form",
    "parentFormData",
    "entityId",
    "entityDataId",
    "entityData",
    "selfTemplateId",
    "templateName",
    "templateData",
    "allEntitiesData",
    "allFieldsData",
    "entityDetails",
  ],
  data() {
    return {
      showLabel: true,
      selectedSlot: null,
      computedTimeSlots: [],
      appointment_date: null,
      //selectedDate: null,
      bookedSlots: [],
      isFreeStyle: false,
      dependencyFields: [],
      bufferTime: 0,
      allowToReschedule: false,
    };
  },
  async mounted() {
    if (this.data.styles?.labelStyle === "hide") {
      this.showLabel = false;
    }

    this.setReferenceData();
    this.selectedSlot = this.form[this.data.key];
    this.dependencyFields = this.data.slot_settings.dependencyFields || [];
    this.appointment_date = this.data.slot_settings.appointment_date;
    this.allowToReschedule = this.data.properties.allow_user_to_reschedule;
    this.bufferTime =
      this.form[this.data.slot_settings.bufferTime] ||
      this.data.slot_settings.bufferTime ||
      0;
    this.selectedDate = this.form[this.appointment_date];
    if (
      this.form &&
      this.appointment_date &&
      this.form[this.appointment_date]
    ) {
      this.selectedDate = this.form[this.appointment_date];
    } else {
      this.selectedDate = null;
    }
    if (this.selectedDate && this.allowToReschedule) {
      await this.checkAvailableSlots();
      if (this.entityId) {
        await this.getEntityDataByFilter();
      }
    }
  },
  computed: {
    ...mapGetters("navigationOpen", ["getIsMobile"]),
    getStyle() {
      if (this.getIsMobile || !this.isFreeStyle) {
        return this.getElementStyle;
      }
      return (
        `height:${this.data.height}px;width:${this.data.width}px;overflow:auto;` +
        this.getElementStyle
      );
    },
    getLabelStyles() {
      return this.data.styles && this.data.styles.label_color
        ? `color: ${this.data.styles.label_color}`
        : "";
    },
    getElementStyle() {
      let borderStyle = "";
      if (this.data.styles) {
        let type = this.data.styles.border_type
          ? this.data.styles.border_type
          : "solid";
        let size = this.data.styles.border_size
          ? this.data.styles.border_size + "px"
          : "0px";
        let color = this.data.styles.border_color
          ? this.data.styles.border_color
          : "";
        let font_size =
          this.data.styles &&
          this.data.styles.font &&
          this.data.styles.font.font_size
            ? this.data.styles.font.font_size
            : 14;
        let bold =
          this.data.styles &&
          this.data.styles.font &&
          (this.data.styles.font.style == 1 || this.data.styles.font.style == 3)
            ? "bold"
            : "";
        let italic =
          this.data.styles &&
          this.data.styles.font &&
          (this.data.styles.font.style == 2 || this.data.styles.font.style == 3)
            ? "italic"
            : "";

        borderStyle = "border:" + type + " " + " " + size + " " + color;

        borderStyle += ";";
        borderStyle += this.data.styles.background
          ? `background: ${this.data.styles.background}`
          : "";
        borderStyle += ";";
        borderStyle += "font-size:" + font_size + "px;";
        if (bold) {
          borderStyle += "font-weight:" + bold + ";";
        }
        if (italic) {
          borderStyle += "font-style:" + italic + ";";
        }
        borderStyle += this.data.styles.label_color
          ? `color: ${this.data.styles.label_color}`
          : "";
        borderStyle += ";";
      }
      return borderStyle;
    },
    selectedDate: {
      get() {
        return this.form && this.appointment_date
          ? this.form[this.appointment_date] || null
          : null;
      },
      set(value) {
        if (this.form && this.appointment_date) {
          this.$set(this.form, this.appointment_date, value);
        }
      },
    },
    dependencyFieldValues() {
      const deps = this.data.slot_settings?.dependencyFields || [];
      return deps.reduce((acc, key) => {
        acc[key] = this.form[key];
        return acc;
      }, {});
    },
  },
  watch: {
    selectedDate: {
      immediate: true,
      handler: async function (newDate) {
        if (!newDate || isNaN(new Date(newDate))) {
          return;
        }
        await this.checkAvailableSlots();
        if (this.entityId) {
          await this.getEntityDataByFilter();
        }
      },
    },
    dependencyFieldValues: {
      handler(newVal, oldVal) {
        if (!oldVal) return;
        const changed = Object.keys(newVal).some(
          (key) => newVal[key] !== oldVal[key]
        );

        if (changed && this.selectedDate) {
          if (this.entityId) {
            this.getEntityDataByFilter();
            this.checkAvailableSlots();
          }
        }
      },
      deep: true,
      immediate: true,
    },
    form: {
      async handler() {
        if (this.data?.slot_settings?.appointment_date) {
          await this.setReferenceData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setReferenceData() {
      this.selectedSlot = this.form[this.data.key];
      this.bufferTime =
        this.form[this.data.slot_settings.bufferTime] ||
        this.data.slot_settings.bufferTime ||
        0;
      this.selectedDate = this.form[this.appointment_date];
      if (this.selectedDate) {
        this.checkAvailableSlots();
      }
    },
    async checkAvailableSlots() {
      let startTime = this.data.slot_settings?.startTime;
      let endTime = this.data.slot_settings?.endTime;
      startTime = this.form[startTime];
      endTime = this.form[endTime];
      let slotDuration =
        this.form[this.data.slot_settings.slotDuration] ||
        this.data.slot_settings.slotDuration ||
        15;
      this.bufferTime =
        this.form[this.data.slot_settings.bufferTime] ||
        this.data.slot_settings.bufferTime ||
        0;
      this.bufferTime = !isNaN(this.bufferTime) ? this.bufferTime : 0;
      this.computedTimeSlots = await this.generateTimeSlots(
        startTime,
        endTime,
        slotDuration,
        this.bufferTime
      );
    },

    async generateTimeSlots(startTime, endTime, slotDuration, bufferTime) {
      try {
        const slots = [];
        const [startHour, startMinute] = startTime.split(":").map(Number);
        const [endHour, endMinute] = endTime.split(":").map(Number);

        let current = new Date();
        current.setHours(startHour, startMinute, 0, 0);

        const end = new Date();
        end.setHours(endHour, endMinute, 0, 0);

        while (
          current.getTime() + (slotDuration + bufferTime) * 60000 <=
          end.getTime()
        ) {
          const slotStart = new Date(current);
          const slotEnd = new Date(current.getTime() + slotDuration * 60000);

          const formatTime = (date) =>
            date.getHours().toString().padStart(2, "0") +
            ":" +
            date.getMinutes().toString().padStart(2, "0");

          slots.push({
            start: formatTime(slotStart),
            end: formatTime(slotEnd),
          });

          current.setMinutes(current.getMinutes() + slotDuration + bufferTime);
        }
        return slots;
      } catch (err) {
        return [];
      }
    },

    isSlotAvailable(slot) {
      return !this.bookedSlots.includes(slot);
    },
    selectSlot(slot) {
      this.selectedSlot = slot;
      this.$set(this.form, this.data.key, slot); // Save selected slot to form
      //this.$emit("input", slot);
    },
    async getEntityDataByFilter() {
      let params = {
        entity_id: this.entityId,
        filters: await this.prepareFilters(),
        limit: 500,
        page: 1,
      };
      let entityDataaa = await postAPICall(
        "POST",
        "/entities-data/entity/data",
        params
      );
      let dataRecords = entityDataaa.data;
      this.bookedSlots = dataRecords
        .map((item) => item.entityData?.[this.selfTemplateId]?.[this.data.key])
        .filter((slot) => slot !== undefined);
      this.bookedSlots = this.bookedSlots.filter(
        (slot) => slot !== this.selectedSlot
      );
    },
    async prepareFilters() {
      try {
        if (!this.selectedDate || isNaN(new Date(this.selectedDate))) {
          return [];
        }
        const appointmentKey = this.appointment_date;
        const filteredFields = this.fieldsData.filter(
          (field) =>
            this.dependencyFields.includes(field.key) ||
            field.key === appointmentKey
        );

        const filters = filteredFields.map((field) => {
          const isDateField = field.key === appointmentKey;
          const isSelectField = field.input_type === "SELECT";
          const isArrayType = field.data_type === "ARRAY";

          let value;
          if (isDateField) {
            const selectedDate = new Date(this.selectedDate);
            const startIST = new Date(selectedDate);
            startIST.setHours(0, 0, 0, 0);

            const endIST = new Date(selectedDate);
            endIST.setHours(23, 59, 59, 999);

            const startUTC = new Date(
              startIST.getTime() - 5.5 * 60 * 60 * 1000
            ).toISOString();
            const endUTC = new Date(
              endIST.getTime() - 5.5 * 60 * 60 * 1000
            ).toISOString();
            value = [startUTC, endUTC];
          } else if (isSelectField && isArrayType) {
            value = this.form[field.key] || [];
          } else {
            value = [`${this.form[field.key]}`];
          }

          return {
            field: `${this.selfTemplateId}#${field.key}`,
            operator: isDateField ? "between" : "in",
            value: value,
            value_type: "",
            value_source: "",
            data_type: isDateField ? "DATE" : field.data_type || "OBJECT_ID",
            query_type: "AND",
            value_field: "",
            validations: {
              data_type: "",
            },
            relation_entity_id: isDateField
              ? ""
              : this.getRelationEntityId(field.key),
            relational_filter_query: "includes",
            isUserFilter: false,
            is_date_time: isDateField,
            data_source: isDateField ? "VALUE" : "ENTITY_DATA_LIST",
            input_type: isDateField ? "DATE" : field.input_type || "ENTITY",
            ...(isDateField && {
              today: new Date(
                new Date().setUTCHours(-5, -30, 0, 0) + 86400000
              ).toISOString(),
            }),
            current_date: new Date(
              new Date().setUTCHours(-5, -30, 0, 0)
            ).toISOString(),
          };
        });

        return filters;
      } catch (error) {
        return [];
      }
    },
    getRelationEntityId(fieldKey) {
      const field = this.fieldsData.find((f) => f.key === fieldKey);
      return field?.entity_id || "";
    },
  },
};
</script>

<style lang="scss">
.resposive-font {
  font-size: 1.2vw;
  line-height: 1.5;
}

.transparentcol {
  color: white;
  display: inline-block;
  height: 20px;
  opacity: 0;
}

.slots {
  display: flex;
  flex-wrap: wrap;
  // margin-top: 10px;
  // height: 100px;
  max-height: 150px;
  overflow-y: scroll;
  padding-bottom: 30px;
  text-align: center;
}
.slot {
  padding: 5px;
  margin: 5px;
  //width: 9%;
  // height: 150px;
  border: 1px solid #3f3a3a;
  cursor: pointer;
  border-radius: 4px;
}
.slot.available {
  background-color: #4d58ef;
  color: white;
  height: 20%;
}
.slot.selected {
  background-color: #3e912a;
  //font-weight: bold;
  color: white//black;
}
.slot.disabled {
  background-color: #eee;
  cursor: not-allowed;
  color: #080808;
  height: 20%;
}
.outer {
  border: 1px solid #ccc;
  border-radius: 12px;
  overflow: hidden;
  max-height: 150px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.inner {
  height: 100%;
  overflow-y: auto;
  margin: 2% 2% 5% 2%;
}

/* Optional: Customize scrollbar for WebKit browsers */
.inner::-webkit-scrollbar {
  width: 8px;
}

.inner::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

.inner::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}

.inner::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
